/**
 * Creates a vertical drag handler that adjusts a numeric value (e.g. height)
 * based on mouse movement along the Y axis.
 */
export const ui = {
  createVerticalDragHandler: ({
    minValue,
    currentValue,
    onDrag,
  }: {
    minValue: number;
    currentValue: number;
    onDrag: (value: number) => void;
  }) => {
    return (e: React.MouseEvent) => {
      e.preventDefault();
      const startY = e.clientY;
      let dragging = true;

      const handleMouseMove = (moveEvent: MouseEvent) => {
        if (!dragging) return;
        const delta = moveEvent.clientY - startY;
        onDrag(Math.max(minValue, currentValue + delta));
      };

      const handleMouseUp = () => {
        dragging = false;
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
      };

      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
    };
  },
};
